function getDiff(a, b) {
  return Math.abs(a - b);
}

/**
 * Return the closest number that is greater or equal to value.
 * If theres is no greater, returns value.
 */
function findGreaterClosestNumber(array, value) {
  const { length } = array;

  if (!length) return value;

  let closestNumber = null;
  let minDiffValue = Number.MAX_VALUE;

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < length; i++) {
    const actual = array[i];
    if (actual >= value) {
      const diff = getDiff(value, actual);
      if (minDiffValue > diff) {
        minDiffValue = diff;
        closestNumber = actual;
      }
    }
  }

  return closestNumber || value;
}

export default findGreaterClosestNumber;
